
<ng-template
	[ngIf]="showLoader === true && loading === true && (displayComponent == null || componentReference == null)">
	<div class="ui-g-12 no-padding text-center">
		<i class="loading-spinner theme-color fa fa-fw fa-spin fa-spinner">
		</i>
	</div>
</ng-template>